import React, { useState } from 'react';
import { ContactInput } from 'sr-types/lib/person/v1/graphql';
import { FormProvider } from '../../../common/form/FormContext';
import FormModal from '../../../common/form/FormModal';
import I18n from '../../../common/i18n/I18n';
import BusinessContacts from './BusinessContacts';

export default ({
    isOpen,
    onClose,
    businessContacts
}: {
    isOpen: boolean;
    onClose: () => void;
    businessContacts: ContactInput[];
}) => {
    const [state, setState] = useState({ businessContacts });

    return (
        <FormModal
            id={'businessContactsPreview'}
            title={<I18n token="person.business.contacts" />}
            isOpen={isOpen}
            onClose={onClose}
            hideButtons
        >
            <FormProvider state={state} setState={setState}>
                <BusinessContacts directAddContact directDeleteContact />
            </FormProvider>
        </FormModal>
    );
};
